import BigNumber from 'bignumber.js'
import { ForceMaxRatio, SafeLTVRatio } from 'constants/constants'
import { ZERO } from 'constants/number'
import { useMemo } from 'react'

interface Props {
  walletTotalDebtValueUSD?: BigNumber
  walletCollateralValueUSD?: BigNumber
  mode: 'borrow' | 'withdraw'
}
const useSafeRatioHelper = ({
  walletTotalDebtValueUSD,
  walletCollateralValueUSD,
  mode,
}: Props) => {
  const safeRatioUSD = useMemo(() => {
    const _safeRatio = new BigNumber(SafeLTVRatio / 100)
    if (!walletCollateralValueUSD) return ZERO

    if (mode === 'borrow')
      return _safeRatio
        .times(walletCollateralValueUSD)
        .minus(walletTotalDebtValueUSD || ZERO)

    if (mode === 'withdraw')
      return walletCollateralValueUSD.minus(
        (walletTotalDebtValueUSD || ZERO).div(_safeRatio),
      )

    return ZERO
  }, [mode, walletCollateralValueUSD, walletTotalDebtValueUSD])

  const forceMaxUSD = useMemo(() => {
    const _forceMaxRatio = new BigNumber(ForceMaxRatio / 100)
    if (!walletCollateralValueUSD) return ZERO

    if (mode === 'borrow')
      return _forceMaxRatio
        .times(walletCollateralValueUSD)
        .minus(walletTotalDebtValueUSD || ZERO)

    if (mode === 'withdraw')
      return walletCollateralValueUSD.minus(
        (walletTotalDebtValueUSD || ZERO).div(_forceMaxRatio),
      )

    return ZERO
  }, [mode, walletCollateralValueUSD, walletTotalDebtValueUSD])

  return { safeRatioUSD, forceMaxUSD }
}

export default useSafeRatioHelper
